enum MediaType {
  SD = 'SD',
  HD = 'HD',
  FULL_HD = 'FullHD',
  FOUR_K = '4K',
}

type MediaSizeMapEntry = {
  [key: string]: MediaType;
};

const MediaSizeMap: MediaSizeMapEntry = {
  640: MediaType.SD,
  1280: MediaType.HD,
  1920: MediaType.FULL_HD,
  3840: MediaType.FOUR_K,
};

export default function getMediaQuality(
  mediaQuality: number
): MediaType | null {
  return MediaSizeMap[mediaQuality] || null;
}
